import React, {Component} from 'react';
import styled, {keyframes} from 'react-emotion';
import {withRouter} from 'react-router-dom';

import {
	FlexRow, lightBeige, H4, primaryWhite,
} from '../../utils/content';

import {ReactComponent as Arbre1} from './arbre1.svg';
import {ReactComponent as Arbre2} from './arbre2.svg';
import {ReactComponent as Arbre3} from './arbre3.svg';

const slideTop = keyframes`
	from {
		opacity: 0;
		transform: translate3d(0, -300%, 0);
		filter: blur(3px);
	}
	to {
		filter: blur(0px);
		opacity: 1;
		transform: translate3d(0, 0%, 0);
	}
`;

const HomeMainContentMain = styled('div')`
	display: block;
	animation: ${slideTop} 0.8s ease-out;
	@media screen and (max-width: 900px) {
		padding-top: 0;
	}
`;

const Trees = styled(FlexRow)`
	@media screen and (max-width: 900px) {
		height: calc(100vh - 180px);
		display: inline;
	}
`;

const PlayTitle = styled(H4)`
	font-variant: small-caps;
	letter-spacing: 8px;
	color: ${primaryWhite};
	font-family: 'BWHaas', sans-serif;
	cursor: pointer;
	transition: color 0.3s ease;
	font-size: 110%;
	@media screen and (max-width: 900px) {
		color: black;
		letter-spacing: 5px;
		font-weight: bold;
		letter-spacing: 3px;
	}
`;

const Tree = styled('div')`
	cursor: pointer;
	text-align: center;
	svg {
		height: 150px;
		width: auto;
		transition: all 0.3s ease;
		display: block;
		margin-left: auto;
		margin-right: auto;
	}
	h4 {
		cursor: pointer;
		transition: all 0.3s ease;
		opacity: 0;
		filter: blur(3px);
		&:hover {
			color: ${lightBeige};
		}
	}

	&:hover {
		h4 {
			opacity: 1;
			filter: blur(0px);
		}
		svg {
			filter: blur(1px);
		}
	}
	@media screen and (max-width: 900px) {
		margin-top: 0px;
		svg {
			height: 0px;
		}
		h4 {
			opacity: 1;
			filter: blur(0px);
			text-align: center;
			font-size: 25px;
		}
	}
`;

class HomeMainContent extends Component {
	render() {
		return (
			<HomeMainContentMain>
				<Trees justifyContent="space-between">
					<Tree
						onClick={() => {
							this.props.history.push('/play/arma');
						}}
						marginTop="15vh"
					>
						<Arbre1 />
						<PlayTitle>au revoir mon amour</PlayTitle>
					</Tree>
					<Tree
						onClick={() => {
							this.props.history.push('/play/ep');
						}}
						marginTop="25vh"
					>
						<Arbre3 />
						<PlayTitle>éclairage public</PlayTitle>
					</Tree>
					<Tree
						onClick={() => {
							this.props.history.push('/play/empreinte');
						}}
						marginTop="5vh"
					>
						<Arbre2 />
						<PlayTitle>l'empreinte</PlayTitle>
					</Tree>
					<Tree
						onClick={() => {
							this.props.history.push('/play/wtml');
						}}
						marginTop="15vh"
					>
						<Arbre1 />
						<PlayTitle>welcome to my life</PlayTitle>
					</Tree>
					<Tree
						onClick={() => {
							this.props.history.push('/play/ritournelle');
						}}
						marginTop="15vh"
					>
						<Arbre2 />
						<PlayTitle>le spectacle de la nature</PlayTitle>
					</Tree>
				</Trees>
			</HomeMainContentMain>
		);
	}
}

export default withRouter(HomeMainContent);
